import { render, staticRenderFns } from "./place-view-page.vue?vue&type=template&id=05d6af50&"
import script from "./place-view-page.vue?vue&type=script&lang=js&"
export * from "./place-view-page.vue?vue&type=script&lang=js&"
import style0 from "./place-view-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
